<template>
  <footer>
    <small>Designed & Built by Allan Kirui.</small>
  </footer>
</template>

<style scoped>
footer {
  width: 100%;
  height: 6vh;
  text-align: center;
}
</style>